import { Link } from "react-router-dom";
import { slugify } from "../../../utils";
import PropTypes from "prop-types";

const CalendarIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
);

const UserIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
    </svg>
);

const ArrowRightIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
);

const BlogItem = ({ data }) => {
    // Determine the main category for the badge (first one)
    const mainCategory = data.categories && data.categories[0];

    return (
        <div className="blog-card-modern">
            <div className="blog-thumb">
                <Link to={process.env.PUBLIC_URL + `/blog-details/${data.id}`}>
                    <picture>
                        <source
                            srcSet={`${
                                process.env.PUBLIC_URL
                            }/${data.media.thumb.replace(
                                /\.(jpg|jpeg|png)$/i,
                                ".webp"
                            )}`}
                            type="image/webp"
                        />
                        <img
                            src={`${process.env.PUBLIC_URL}/${data.media.thumb}`}
                            alt={data.title}
                            loading="lazy"
                            decoding="async"
                            width="800"
                            height="500"
                        />
                    </picture>
                </Link>
                {mainCategory && (
                    <Link
                        to={
                            process.env.PUBLIC_URL +
                            `/category/${slugify(mainCategory)}`
                        }
                        className="category-badge"
                    >
                        {mainCategory}
                    </Link>
                )}
            </div>

            <div className="blog-content">
                <div className="meta-info">
                    <span className="date">
                        <CalendarIcon />
                        {data.date}
                    </span>
                    <span className="author">
                        <UserIcon />
                        <Link
                            to={
                                process.env.PUBLIC_URL +
                                `/author/${slugify(data.author)}`
                            }
                        >
                            {data.author}
                        </Link>
                    </span>
                </div>

                <h3 className="title">
                    <Link
                        to={process.env.PUBLIC_URL + `/blog-details/${data.id}`}
                    >
                        {data.title}
                    </Link>
                </h3>

                <p>{data.excerpt}</p>

                <div className="read-more-wrapper">
                    <Link
                        to={process.env.PUBLIC_URL + `/blog-details/${data.id}`}
                        className="read-more-btn"
                    >
                        Read More <ArrowRightIcon />
                    </Link>
                </div>
            </div>
        </div>
    );
};

BlogItem.propTypes = {
    data: PropTypes.object,
};

export default BlogItem;
